/* eslint-disable consistent-return */
export const getBgColor = ( {
  value,
  i,
  isTotal,
  isLast,
  isFinished,
  targetPace,
  hasColor,
  rowTitle,
  timings,
  ...props
} ) => {
  if ( !hasColor ) return
  
  if ( rowTitle === 'Inspection' ) return getInspectionBgColor( value, timings )

  if ( !props.row.id || !isValidPace( value ) || ( isLast && !isFinished ) ) return
  if ( !isValidPace( targetPace ) ) return 'var(--color-base050)'

  return parseFloat( value ) > parseFloat( targetPace ) ? '#FF807B' : '#93F291'
}

export const getStyle = ( {
  value,
  i,
  isTotal,
  isLast,
  targetPace,
  isFinished,
  ...props
} ) => {
  if ( !isLast || isFinished ) return
  if ( Number.isNaN( parseFloat( targetPace ) ) ) {
    return {
      border : '5px solid var(--color-base300)',
    } 
  }
  if ( parseFloat( value ) > parseFloat( targetPace ) ) {
    return {
      color : '#DB253D',
      border : '5px solid #DB253D',
    }
  }
  return {
    color : '#057B27',
    border : '5px solid #057B27',
  }
}

export const getDuration = ( ms, hide = true ) => {
  const days = Math.floor( ms / ( 24 * 60 * 60 * 1000 ) )
  const daysms = ms % ( 24 * 60 * 60 * 1000 )
  const hours = Math.floor( daysms / ( 60 * 60 * 1000 ) )
  const hoursms = ms % ( 60 * 60 * 1000 )
  const minutes = Math.floor( hoursms / ( 60 * 1000 ) )
  return `${days}d : ${hours}h : ${minutes}m`
}

export const formatPaceTimes = ( pace, config ) => {
  if ( !pace ) return '-'
  return Intl.NumberFormat( undefined, {
    minimumFractionDigits : 2,
    maximumFractionDigits : 2,
    ...config,
  } ).format( Number.isNaN( pace ) ? 0 : pace )
}

function getInspectionBgColor( value, timings ) {
  const start = timings?.[0]
  const end = timings?.[1]
  return !!start && !!end ?
    parseFloat( value ) < 100 ?
      '#FF807B' :
      undefined :
    undefined
}

function isValidPace( value ) { return !Number.isNaN( parseFloat( value ) ) }
